import { useEffect, useState } from "react";
import { formatDistance, format, setDefaultOptions } from 'date-fns'
import { w2popup } from 'https://cdn.jsdelivr.net/gh/vitmalina/w2ui@master/dist/w2ui.es6.min.js'
import SectionJobsImages from "../../sections/jobs/section-jobs-images";
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { TbCopy } from "react-icons/tb";
import { BsCardImage, BsSave } from "react-icons/bs";
import { MdEdit } from "react-icons/md";
import { db } from "../../../../../globals/firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { pt } from 'date-fns/locale'
import { LazyLoadImage } from "react-lazy-load-image-component";



function JobDetail1Page(document) {

    const [docatual, setdocatual] = useState(null)
    const [modaldetails, setmodaldetails] = useState(false);
    const [edit, setedit] = useState(false);
    const [textedit, settextedit] = useState("");
    const [userid, setuserid] = useState(null)
    const { t, i18n } = useTranslation()

    useEffect(() => {
        const userlogged = JSON.parse(localStorage.getItem("user"))
        if (userlogged != null) {
            setuserid(userlogged.userid)
        }
        
        if (i18n.language == "pt-br") {
            setDefaultOptions({ locale: pt })
        }


    }, [])




    const notify = (type, wait, message) => {
        if (wait == false) {
            let color = ""

            if (type == 'Error') {
                w2popup.close()
                color = 'red'
            }

            if (type == 'Success') {
                color = 'green'
            }

            if (type == 'Message') {
                color = 'gold'
            }


            const title = '<span style="color:' + color + ';font-weight:bold">' + type + '</span>'
            const messagebody = '<span style="color:' + color + '">' + message + '</span>'

            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                title: title,
                body: messagebody,
                showClose: true,
                actions: {
                    Ok(event) {
                        w2popup.close()
                    }
                }
            })
        }
        if (wait == true) {
            w2popup.open({
                modal: true,
                width: 250,       // width of the popup
                height: 150,       // height of the popup
                color: '#000',
                text: t("general.pleasewait"),
                showClose: false,

            })


        }
    }

    const changeedit = () => {
        const status = edit
        setedit(!status)
    }

    const savedoc = async (documento) => {
        const docRef = doc(db, "wpm_prompts", documento.id)
        await updateDoc(docRef, {
            prompttext: textedit
        });

    }



    return (
        <>


            <div className="row">


                <Modal
                    open={modaldetails}
                    onClose={() => setmodaldetails(false)}
                    center
                    styles={{
                        background: '#b2dbbf',
                        width: '100%'
                    }}
                    //onAfterOpen={afterOpenModal}
                    onRequestClose={() => setmodaldetails(false)}
                //style={customStyles}
                //contentLabel="Example Modal"
                >
                    <div>
                        {docatual != null ?
                            <SectionJobsImages doc={docatual}></SectionJobsImages>
                            :
                            ""}
                    </div>
                </Modal>

                <div className="col-md-12">
                    <div className="twm-jobs-grid-style1">
                        <div style={{ padding: "5px", borderRadius: "15px" }} className="card-body">
                            {document.doc.username != null && document.doc.username != "" ?
                                <span style={{ fontSize: "9px", fontWeight: "bold" }}>{t('promptsroot.by')} {document.doc.username} - {(formatDistance(document.doc.dateinsert, Date.now(), { addSuffix: true }))}</span>
                                :
                                <span style={{ fontSize: "9px", fontWeight: "bold" }}>{(formatDistance(document.doc.dateinsert, Date.now(), { addSuffix: true }))}</span>
                            }

                        </div>
                        {document.doc.imageurl !== "" ?
                            <div>
                                <div >
                                    <LazyLoadImage style={{ borderRadius: "10px", Border: "5px 5px 40px rgba(56, 152, 226, 0.3)" }} src={document.doc.imageurl} alt="#" />
                                </div>

                            </div>

                            :

                            <div>
                                <div>
                                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>{document.doc.prompttitle}</span>
                                </div>

                            </div>
                        }

                        <div>
                            {edit == false ?
                                <span style={{ fontSize: "10px" }}>{document.doc.prompt}</span>
                                :
                                <textarea id="txtArea" rows="8" style={{ width: '100%' }} value={textedit} onChange={(e) => { e.preventDefault(); settextedit(e.target.value) }}></textarea>
                            }
                        </div>


                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly", justifyItems: "center", width: "100%" }}>
                            <button type="submit" className="site-button" onClick={(e) => { e.preventDefault(); navigator.clipboard.writeText(document.doc.prompt); notify(t('promptsroot.message'), false, t('promptsroot.copied')) }}>
                                <TbCopy color="white" size="15" />
                                {t('promptsroot.copy')}</button>
                            {userid != null ?
                                document.doc.userid == userid ?
                                    <button type="submit" className="site-button"
                                        onClick={(e) => {
                                            if (edit == false) {
                                                e.preventDefault();
                                                settextedit(document.doc.prompt)
                                            }
                                            else {
                                                savedoc(document.doc)
                                            }
                                            changeedit();

                                        }}>
                                        <MdEdit color="white" size="15" />
                                        {edit == false ?
                                            t('promptsroot.edit')
                                            :
                                            t('promptsroot.save')
                                        }

                                    </button>
                                    : ""
                                : ""}
                            <button onClick={(e) => { e.preventDefault(); setdocatual(document.doc); setmodaldetails(true) }} className="site-button" type="button">
                                <BsCardImage color="white" size="15" />
                                {t('promptsroot.imagesgeneration')}</button>

                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default JobDetail1Page;